import 'reflect-metadata';
import { Container } from 'inversify';

/**
 * Contenedor de Inversion of Control (inversify).
 * Todavia no registra providers: se ira completando a medida que existan
 * casos de uso, repositorios e implementaciones de infraestructura reales.
 */
const container = new Container({
  defaultScope: 'Singleton',
});

export function configureDependencies(): void {
  // Los providers (repositorios, servicios http, casos de uso) se registran aca.
}

export { container };
